import React from "react";
import { FormControl, FormHelperText, InputLabel, OutlinedInput } from "@mui/material";
import { isFieldRequired } from "../../../helpers";

const Input = ({ label, name, value, error, touched, validationSchema, ...props }) => {
    const isRequired = validationSchema ? isFieldRequired(validationSchema, name) : false;
    
    return (
        <FormControl fullWidth variant="outlined" required={isRequired}>
            <InputLabel htmlFor={name}>{label}</InputLabel>
            <OutlinedInput
                id={name}
                type="text"
                label={label}
                name={name}
                value={value}
                {...props} // Pass all additional props (onChange, onBlur, etc.)
            />
            {touched && error && <FormHelperText error>{error}</FormHelperText>}
        </FormControl>
    );
};

export default Input;